import React from "react";
import Form from 'react-bootstrap/Form';
import Props from "../../models/Properties"

import InputString from "./InputString"
import InputInteger from "./InputInteger"
import InputFloat from "./InputFloat"
import InputFloat2 from "./InputFloat2"
import InputFloat3 from "./InputFloat3"
import InputFloat4 from "./InputFloat4"
import InputBool from "./InputBool"
import InputEnum from "./InputEnum"

const PropItem: React.FC<{data: any}> = (props) => {
    const [controlId, setControlId] = React.useState('');
    React.useEffect(() => {
        setControlId(generateControlId());
      }, []);
  
      function generateControlId() {
          return `checkbox-group-${Math.floor(Math.random() * 1000000)}`;
      };

    return (
        <div style={{ marginBottom: "var(--margin)"}}>
            <Form.Group controlId={controlId} style={{color: Props.checkModified(props.data.prop) ? "red" : ""}}>
                {props.data.prop.type == 'string' && (<InputString data={props.data}/>)}
                {props.data.prop.type == 'integer' && (<InputInteger data={props.data}/>)}
                {props.data.prop.type == 'float' && (<InputFloat data={props.data}/>)}
                {props.data.prop.type == 'float2' && (<InputFloat2 data={props.data}/>)}
                {props.data.prop.type == 'float3' && (<InputFloat3 data={props.data}/>)}
                {props.data.prop.type == 'float4' && (<InputFloat4 data={props.data}/>)}
                {props.data.prop.type == 'bool' && (<InputBool data={props.data}/>)}
                {props.data.prop.type == 'enum' && (<InputEnum data={props.data}/>)}
            </Form.Group>
        </div>
    );
};

export default PropItem;
